import { SET_NO_DEFAULT } from "../../redux/actions/action.types";

export default function setNoDefault(stateHandler: any, status: any) {
  stateHandler({
    type: SET_NO_DEFAULT,
    payload: status,
  });
}
